var _rect, _line, _line2, _line3, _line4, _line5, _rect2, _line6, _line7, _line8, _line9, _line0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxplot = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 5,
  width: 4,
  height: 6,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 2,
  x2: 4,
  y2: 5,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 11,
  x2: 4,
  y2: 14,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 2,
  y1: 8,
  x2: 6,
  y2: 8,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 2.5,
  y1: 2,
  x2: 5.5,
  y2: 2,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 2.5,
  y1: 14,
  x2: 5.5,
  y2: 14,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 4,
  width: 4,
  height: 5,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 1,
  x2: 12,
  y2: 4,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 9,
  x2: 12,
  y2: 12,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  x1: 10,
  y1: 6.5,
  x2: 14,
  y2: 6.5,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  x1: 10.5,
  y1: 1,
  x2: 13.5,
  y2: 1,
  stroke: "currentColor",
  strokeWidth: 1.5
})), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
  x1: 10.5,
  y1: 12,
  x2: 13.5,
  y2: 12,
  stroke: "currentColor",
  strokeWidth: 1.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxplot);
export default ForwardRef;